import axios from '../axios'

/*
 * 意见反馈
 */

export const selectByPage = (data) => {
    return axios({
        url: '/feedback/selectByPage',
        method: 'post',
        data
    })
}

export const batchReply = (data) => {
    return axios({
        url: '/feedback/batchReply',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/feedback/batchDelete',
        method: 'post',
        data
    })
}





// WEBPACK FOOTER //
// ./src/http/other/feedback.js